import usePaymentsByOwner from './usePaymentsByOwner2';

export { usePaymentsByOwner };
